<template>
    <div class="userdata">
        <NavBar />
        <div class="wholePage">
            <hr />
            <div accordion not-arrow>
                <div v-for="tests in storedTranscriptions" :key="tests.id">
                    <div>
                        <vs-tabs alignment="center" class="white">
                            <vs-tab
                                @click="
                                    loadDiff(
                                        tests.id + '___' + test[`test${key + 1}`].audioSelected,
                                        getTranscriptText(test[`test${key + 1}`]),
                                    )
                                "
                                :label="'Test ' + (key + 1)"
                                :key="key"
                                v-for="(test, key) in tests.tests"
                            >
                                <div style="font-size: 20px">Email: {{ currentUseremail }}</div>
                                <div>Title: {{ test[`test${key + 1}`].audioSelected[0] }}</div>
                                <div>
                                    Diff:
                                    <span
                                        :ref="
                                            tests.id +
                                            '0' +
                                            '---' +
                                            test[`test${key + 1}`].audioSelected
                                        "
                                        >{{ test[`test${key + 1}`].jsDiff }}</span
                                    >%
                                </div>
                                <div>
                                    Accuracy:
                                    <span
                                        :ref="
                                            tests.id +
                                            '1' +
                                            '---' +
                                            test[`test${key + 1}`].audioSelected
                                        "
                                        >{{ test[`test${key + 1}`].accuracy }}</span
                                    >%
                                </div>
                                <div>
                                    Test Time:
                                    {{ getTime(test[`test${key + 1}`].timetaken) }}
                                </div>
                                <div :ref="tests.id + '___' + test[`test${key + 1}`].audioSelected">
                                    <div v-show="false">
                                        {{ getTranscriptText(test[`test${key + 1}`]) }}
                                    </div>
                                </div>
                            </vs-tab>
                        </vs-tabs>
                    </div>
                </div>
            </div>
            <hr />
            <br />
            <div class="footer">
                <vs-row vs-type="flex" vs-justify="space-around">
                    <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                        vs-w="10"
                        style="padding-left: 20%; margin-top: 20%"
                        ><vs-button color="primary" type="filled" @click="takePracticeTest"
                            >Start Practice Test</vs-button
                        ></vs-col
                    >
                    <vs-col
                        vs-type="flex"
                        vs-justify="end"
                        vs-align="center"
                        vs-w="2"
                        style="margin-top: 2%"
                    >
                        <div class="my-legend" style="color: white">
                            <div class="legend-title">Legend</div>
                            <div class="legend-scale">
                                <ul class="legend-labels">
                                    <li>
                                        <span style="background: green"></span>Actual Transcript
                                    </li>
                                    <li>
                                        <span style="background: rgb(164, 89, 60)"></span>Mistakes
                                    </li>
                                    <li><span style="background: grey"></span>Correct</li>
                                </ul>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import AlertMsg from '@/mixins/AlertMsg';
import 'firebase/auth';
import NavBar from '@/components/NavBar.vue';
import * as firebase from 'firebase/app';
import * as Diff from 'diff';
import { db } from '../firebase/db';
import 'firebase/database';
import { getSingleUser, getpracticeDataByGroup } from './api/Api';
import diffCalc from '../utilities/diffCalculator';

export default {
    name: 'UserData',
    props: {
        transId: {
            type: String,
        },
    },
    mixins: [AlertMsg],
    data() {
        return {
            storedTranscriptions: null,
            userId: '',
            userData: '',
            originalData: null,
            blockData: null,
        };
    },
    components: {
        NavBar,
    },

    methods: {
        takePracticeTest() {
            this.$store.state.Test.PracticeTest = true;
            this.$router.push({ name: 'PracticeTest' });
        },
        getTime(time) {
            const minsInNum = Math.floor(time / 60);
            const minsPostfix = minsInNum > 1 ? 'minutes' : 'minute';
            const secInNum = time % 60;
            const secsPostfix = secInNum > 1 ? 'seconds' : 'second';
            return `${minsInNum} ${minsPostfix} ${secInNum} ${secsPostfix}`;
        },

        reDiff(ref, transcriptText, choice) {
            const selectedAudio = ref.split('---')[1];
            const originalText = this.originalData[selectedAudio];
            const newData = diffCalc(transcriptText, originalText)[choice];
            this.$refs[ref][0].innerText = newData;
        },

        loadDiff(key, transText) {
            this.$nextTick(() => {
                const audio = key.split('___')[1];
                const element = this.$refs[key][0];
                const originalText = this.originalData[audio];
                const diffBlock = this.produceDiffElement(transText, originalText);
                element.innerHTML = '';
                element.appendChild(diffBlock);
            });
        },
        produceDiffElement(blockText, originalText) {
            let span = null;
            const diff = Diff.diffWords(blockText, originalText);
            const fragment = document.createDocumentFragment();
            diff.forEach((part) => {
                // eslint-disable-next-line no-nested-ternary
                const color = part.added ? 'green' : part.removed ? 'rgb(164,89,60)' : 'grey';
                span = document.createElement('span');
                span.style.color = color;
                if (part.removed) span.style.textDecoration = 'line-through';
                span.appendChild(document.createTextNode(part.value));
                fragment.appendChild(span);
                if (part.removed) fragment.appendChild(document.createTextNode(' '));
            });
            // this.fragment = fragment;
            return fragment;
        },

        getData(mytitle) {
            return this.originalData.find((data) => data.title === mytitle);
        },

        getTranscriptText(transcriptData) {
            return transcriptData.blocks.reduce(
                (fullText, currentBlock) => `${fullText} ${currentBlock.text}`,
                '',
            );
        },

        async getOriginalData(audios) {
            const originalData = {};
            const originalText = await db
                .collection('audioInfo')
                .where('title', 'in', [...audios])
                .get();
            originalText.forEach((mydoc) => {
                originalData[mydoc.data().title] = mydoc.data().comment;
            });
            return originalData;
        },

        async getTranscriptData() {
            const transData = await getpracticeDataByGroup(
                firebase.firestore.FieldPath.documentId(),
                '==',
                this.transId,
            );
            const newData = transData
                .filter((transcript) => transcript.tests)
                .map((transcription) => ({
                    tests: [...transcription.tests],
                    audios: transcription.selectedAudios,
                    date: transcription.date,
                    id: transcription.id,
                }));
            return newData;
        },

        getHardAudios(tests) {
            return tests
                .filter((trans) => trans.hardtest && trans.hardtest.audioSelected)
                .map((trans) => trans.hardtest.audioSelected);
        },

        getAllAudioTitle(transcripts) {
            const allAudio = transcripts.map((trans) => trans.audios).flat();
            const hardAudios = this.getHardAudios(transcripts);
            return Array.from(new Set([...allAudio, ...hardAudios]));
        },
    },

    async created() {
        const user = firebase.auth().currentUser;
        this.currentUseremail = user.email;
        const [userId, userData] = await getSingleUser(this.currentUseremail);
        [this.userId, this.userData] = [userId, userData];
        if (!this.currentUseremail) {
            this.$router.replace({ name: 'Transcriptions' });
        }
    },

    async mounted() {
        const allTests = await this.getTranscriptData();
        const allAudios = this.getAllAudioTitle(allTests);
        this.storedTranscriptions = allTests;
        this.originalData = await this.getOriginalData(allAudios);

        const refs = this.$refs;
        Object.keys(refs).forEach((key) => {
            if (key.includes('___')) {
                const audio = key.split('___')[1];
                const element = refs[key] && refs[key][0];
                if (element) {
                    const transText = element.firstChild.innerText;
                    const originalText = this.originalData[audio];

                    const diffBlock = this.produceDiffElement(transText, originalText);

                    element.innerHTML = '';
                    element.appendChild(diffBlock);
                }
            }
        });
    },
};
</script>
<style scoped>
.wholePage {
    background-color: black;
    height: 100vh;
    margin-top: -2%;
}
table {
    width: 50%;
}
.cardx {
    background-color: #05386bf5;
    color: rgba(250, 235, 215, 0.788);
}
.real {
    margin-right: 30px;
}
.date {
    color: white;
}

.header-collapse {
    color: white;
}
.white {
    color: white;
}
.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    margin-bottom: 5%;
}
.my-legend .legend-title {
    text-align: center;
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 105%;
}
.my-legend .legend-scale ul {
    margin: 0;
    margin-bottom: 5px;
    padding: 0;
    float: left;
    list-style: none;
    text-align: center;
}

.my-legend .legend-scale ul li {
    font-size: 90%;
    list-style: none;
    margin-left: 0;
    line-height: 18px;
    margin-bottom: 2px;
    text-align: left;
}
.my-legend ul.legend-labels li span {
    display: block;
    float: left;
    height: 16px;
    width: 30px;
    margin-right: 5px;
    margin-left: 0;
    border: 1px solid #999;
}
.my-legend .legend-source {
    font-size: 105%;
    color: #999;
    clear: both;
}
.my-legend a {
    color: #777;
}
</style>
